import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import seoLandingPages from '../data/seo-pages.json';

const origin = 'https://www.maintendue.be';

const pages = {
  fr: {
    '/': {
      title: 'TPMR Bruxelles | Transport médical et PMR | Main Tendue',
      description: 'Main Tendue organise le transport TPMR, PMR et médico-sanitaire non urgent à Bruxelles : VSL, fauteuil roulant, hôpital, dialyse et accompagnement.',
      breadcrumb: 'Accueil',
      keywords: ['TPMR Bruxelles', 'transport médico-sanitaire', 'transport TPMR', 'transport PMR', 'transport médical non urgent', 'Main Tendue transport']
    },
    '/services': {
      title: 'Transport PMR, TPMR et VSL à Bruxelles | Main Tendue',
      description: 'Découvrez nos transports PMR, TPMR et VSL à Bruxelles : hôpital, dialyse, fauteuil roulant, seniors, maisons de repos et accompagnement porte à porte.',
      breadcrumb: 'Services et tarifs',
      keywords: ['transport VSL', 'VSL Bruxelles', 'véhicule sanitaire léger', 'transport dialyse', 'transport hôpital', 'transport fauteuil roulant', 'transport maison de repos', 'transport senior']
    },
    '/about': {
      title: 'Main Tendue | Transport TPMR agréé COCOF à Bruxelles',
      description: 'Découvrez Main Tendue, ASBL de transport médico-sanitaire et TPMR agréée COCOF à Bruxelles, partenaire de Partenamut, de CPAS et de maisons de repos.',
      breadcrumb: 'À propos',
      keywords: ['Main Tendue TPMR', 'Main Tendue transport', 'transport agréé COCOF', 'transport Partenamut', 'transport CPAS']
    },
    '/reservation': {
      title: 'Réserver un transport médical à Bruxelles | Main Tendue',
      description: 'Réservez un transport médico-sanitaire, TPMR ou PMR à Bruxelles pour un trajet vers l’hôpital, la dialyse ou avec un fauteuil roulant.',
      breadcrumb: 'Réservation',
      keywords: ['réserver transport médical', 'transport non urgent de patient', 'transport dialyse', 'transport hôpital', 'transport personne à mobilité réduite']
    },
    '/faq': {
      title: 'Transport TPMR, PMR et VSL à Bruxelles : FAQ | Main Tendue',
      description: 'Tarifs, réservation, remboursement mutuelle ou CPAS, VSL, transport PMR et médico-sanitaire : retrouvez les réponses de Main Tendue à Bruxelles.',
      breadcrumb: 'Questions fréquentes',
      keywords: ['transport remboursé mutuelle', 'transport CPAS', 'tarif VSL Bruxelles', 'transport non urgent', 'transport Partenamut']
    },
    '/contact': {
      title: 'Contacter Main Tendue | Transport TPMR à Bruxelles',
      description: 'Contactez Main Tendue pour un transport TPMR, PMR, VSL ou médico-sanitaire non urgent à Bruxelles et un accompagnement adapté.',
      breadcrumb: 'Contact',
      keywords: ['contact Main Tendue', 'Main Tendue transport', 'TPMR Bruxelles', 'transport médical Bruxelles']
    },
    '/policy': {
      title: 'Politique de confidentialité | Main Tendue ASBL',
      description: 'Consultez la politique de confidentialité et les informations relatives au traitement des données par Main Tendue ASBL.',
      breadcrumb: 'Confidentialité',
      keywords: ['Main Tendue ASBL', 'confidentialité']
    }
  },
  nl: {
    '/': {
      title: 'Aangepast medisch vervoer Brussel | Main Tendue',
      description: 'Main Tendue organiseert niet-dringend medisch vervoer en aangepast vervoer voor personen met beperkte mobiliteit in Brussel, met persoonlijke begeleiding.',
      breadcrumb: 'Home',
      keywords: ['medisch vervoer Brussel', 'aangepast vervoer Brussel', 'Main Tendue vervoer']
    },
    '/services': {
      title: 'Medisch en aangepast vervoer in Brussel | Main Tendue',
      description: 'Ontdek onze diensten voor ziekenhuis, dialyse, rolstoelgebruikers, senioren en woonzorgcentra met aangepaste voertuigen en deur-tot-deurbegeleiding.',
      breadcrumb: 'Diensten en tarieven',
      keywords: ['niet-dringend medisch vervoer', 'rolstoelvervoer Brussel', 'dialysevervoer', 'seniorenvervoer']
    },
    '/about': {
      title: 'Main Tendue | COCOF-erkend medisch vervoer Brussel',
      description: 'Ontdek Main Tendue, een Brusselse vzw voor COCOF-erkend medisch vervoer, in samenwerking met Partenamut, OCMW’s en woonzorgcentra.',
      breadcrumb: 'Over ons',
      keywords: ['Main Tendue vervoer', 'COCOF erkend vervoer', 'Partenamut vervoer', 'OCMW vervoer']
    },
    '/reservation': {
      title: 'Niet-dringend medisch vervoer reserveren | Main Tendue',
      description: 'Reserveer aangepast of medisch vervoer in Brussel voor een ziekenhuisbezoek, dialyse, rolstoel of een andere zorgafspraak.',
      breadcrumb: 'Reservatie',
      keywords: ['medisch vervoer reserveren', 'patiëntenvervoer', 'dialysevervoer', 'rolstoelvervoer']
    },
    '/faq': {
      title: 'Vragen over medisch en aangepast vervoer | Main Tendue',
      description: 'Lees alles over tarieven, reservatie, terugbetaling door mutualiteit of OCMW en niet-dringend medisch vervoer met Main Tendue.',
      breadcrumb: 'Veelgestelde vragen',
      keywords: ['terugbetaling medisch vervoer', 'mutualiteit vervoer', 'OCMW vervoer', 'vervoertarieven']
    },
    '/contact': {
      title: 'Contact Main Tendue | Medisch vervoer Brussel',
      description: 'Neem contact op met Main Tendue voor niet-dringend medisch of aangepast vervoer en persoonlijke begeleiding in Brussel.',
      breadcrumb: 'Contact',
      keywords: ['contact Main Tendue', 'medisch vervoer Brussel']
    },
    '/policy': {
      title: 'Privacybeleid | Main Tendue vzw',
      description: 'Lees het privacybeleid en de informatie over de verwerking van persoonsgegevens door Main Tendue vzw.',
      breadcrumb: 'Privacy',
      keywords: ['Main Tendue vzw', 'privacybeleid']
    }
  }
};

Object.entries(seoLandingPages).forEach(([pathname, localizedPage]) => {
  pages.fr[pathname] = localizedPage.fr;
  pages.nl[pathname] = localizedPage.nl;
});

const services = {
  fr: [
    ['Transport médico-sanitaire non urgent', 'Transport de patients vers un hôpital, une clinique, un centre de dialyse ou un autre service de soins.'],
    ['Transport VSL', 'Transport en véhicule sanitaire léger à Bruxelles et hors Bruxelles selon la grille tarifaire en vigueur.'],
    ['Transport PMR et TPMR', 'Transport adapté pour les personnes à mobilité réduite, notamment les passagers en fauteuil roulant.'],
    ['Transport de personnes âgées et seniors', 'Trajets accompagnés depuis le domicile ou une maison de repos, avec assistance porte à porte.'],
    ['Transport non médico-sanitaire', 'Déplacements essentiels, démarches et accompagnement dans Bruxelles ou hors Bruxelles.'],
    ['Transport vers Bruxelles-National', 'Forfait de transport vers l’aéroport de Bruxelles-National au départ de Bruxelles.']
  ],
  nl: [
    ['Niet-dringend medisch vervoer', 'Patiëntenvervoer naar een ziekenhuis, kliniek, dialysecentrum of andere zorgdienst.'],
    ['Vervoer met een licht sanitair voertuig', 'Aangepast sanitair vervoer in en buiten Brussel volgens het geldende tarief.'],
    ['Aangepast rolstoelvervoer', 'Vervoer voor personen met beperkte mobiliteit en passagiers in een rolstoel.'],
    ['Vervoer voor ouderen en senioren', 'Begeleide ritten vanaf de woning of het woonzorgcentrum met deur-tot-deurhulp.'],
    ['Niet-medisch vervoer', 'Essentiële verplaatsingen en begeleiding in of buiten Brussel.'],
    ['Vervoer naar Brussels Airport', 'Vervoer tegen een vast tarief vanuit Brussel naar Brussels Airport.']
  ]
};

function setMeta(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
}

function Seo() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage?.startsWith('nl') ? 'nl' : 'fr';

  useEffect(() => {
    const normalizedPathname = pathname === '/' ? '/' : pathname.replace(/\/+$/, '') || '/';
    const isKnownPage = Boolean(pages[lang][normalizedPathname]);
    const page = isKnownPage
      ? pages[lang][normalizedPathname]
      : {
          title: lang === 'fr' ? 'Page introuvable | Main Tendue' : 'Pagina niet gevonden | Main Tendue',
          description: lang === 'fr' ? 'Cette page n’existe pas ou a été déplacée.' : 'Deze pagina bestaat niet of werd verplaatst.',
          breadcrumb: '',
          keywords: []
        };
    const isSeoLandingPage = Boolean(seoLandingPages[normalizedPathname]);
    const canonicalPathname = isSeoLandingPage ? `${normalizedPathname}/` : normalizedPathname;
    const canonicalUrl = `${origin}${canonicalPathname}`;
    const imageUrl = `${origin}/logo-main-tendue.png`;
    const language = lang === 'fr' ? 'fr-BE' : 'nl-BE';

    document.title = page.title;
    document.documentElement.lang = lang;
    setMeta('meta[name="description"]', { name: 'description', content: page.description });
    setMeta('meta[name="robots"]', {
      name: 'robots',
      content: isKnownPage ? 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1' : 'noindex,nofollow'
    });
    setMeta('meta[name="author"]', { name: 'author', content: 'Main Tendue Pour Tous ASBL' });
    setMeta('meta[name="geo.region"]', { name: 'geo.region', content: 'BE-BRU' });
    setMeta('meta[name="geo.placename"]', { name: 'geo.placename', content: 'Bruxelles' });
    setMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
    setMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: 'Main Tendue' });
    setMeta('meta[property="og:locale"]', { property: 'og:locale', content: lang === 'fr' ? 'fr_BE' : 'nl_BE' });
    setMeta('meta[property="og:locale:alternate"]', { property: 'og:locale:alternate', content: lang === 'fr' ? 'nl_BE' : 'fr_BE' });
    setMeta('meta[property="og:title"]', { property: 'og:title', content: page.title });
    setMeta('meta[property="og:description"]', { property: 'og:description', content: page.description });
    setMeta('meta[property="og:url"]', { property: 'og:url', content: canonicalUrl });
    setMeta('meta[property="og:image"]', { property: 'og:image', content: imageUrl });
    setMeta('meta[property="og:image:alt"]', { property: 'og:image:alt', content: 'Logo de Main Tendue Pour Tous ASBL' });
    setMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
    setMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: page.title });
    setMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: page.description });
    setMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: imageUrl });
    setMeta('meta[name="twitter:image:alt"]', { name: 'twitter:image:alt', content: 'Logo de Main Tendue Pour Tous ASBL' });

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;

    const serviceCatalog = {
      '@type': 'OfferCatalog',
      '@id': `${origin}/#services`,
      name: lang === 'fr' ? 'Services de transport Main Tendue' : 'Vervoersdiensten van Main Tendue',
      itemListElement: services[lang].map(([name, serviceDescription], index) => ({
        '@type': 'Offer',
        position: index + 1,
        itemOffered: {
          '@type': 'Service',
          name,
          description: serviceDescription,
          provider: { '@id': `${origin}/#organization` },
          areaServed: { '@type': 'AdministrativeArea', name: 'Région de Bruxelles-Capitale' }
        }
      }))
    };

    const graph = [
      {
        '@type': 'WebSite',
        '@id': `${origin}/#website`,
        url: `${origin}/`,
        name: 'Main Tendue',
        alternateName: ['Maintendue', 'Main Tendue Pour Tous'],
        inLanguage: ['fr-BE', 'nl-BE'],
        publisher: { '@id': `${origin}/#organization` }
      },
      {
        '@type': ['LocalBusiness', 'Organization'],
        '@id': `${origin}/#organization`,
        name: 'Main Tendue',
        legalName: 'Main Tendue Pour Tous ASBL',
        alternateName: ['Maintendue', 'Main Tendue TPMR'],
        url: `${origin}/`,
        logo: `${origin}/logo-main-tendue.png`,
        image: imageUrl,
        description: lang === 'fr'
          ? 'ASBL bruxelloise agréée COCOF spécialisée dans le transport médico-sanitaire non urgent, TPMR, PMR et VSL.'
          : 'Brusselse vzw met COCOF-erkenning voor niet-dringend medisch en aangepast vervoer.',
        identifier: { '@type': 'PropertyValue', name: 'Agrément COCOF', value: '30.01.14' },
        telephone: '+32491333777',
        email: 'info@maintendue.be',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Route de Lennik 804/126',
          postalCode: '1070',
          addressLocality: 'Bruxelles',
          addressCountry: 'BE'
        },
        areaServed: { '@type': 'AdministrativeArea', name: 'Bruxelles et alentours' },
        openingHoursSpecification: [
          { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '07:00', closes: '17:30' },
          { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Saturday', 'Sunday'], opens: '09:00', closes: '16:00' }
        ],
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+32491333777',
          contactType: 'customer service',
          availableLanguage: ['French', 'Dutch'],
          areaServed: 'BE'
        },
        knowsLanguage: ['fr', 'nl'],
        knowsAbout: pages.fr['/services'].keywords,
        hasOfferCatalog: { '@id': `${origin}/#services` },
        potentialAction: {
          '@type': 'ReserveAction',
          name: lang === 'fr' ? 'Demander un transport' : 'Vervoer aanvragen',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${origin}/reservation`,
            actionPlatform: ['https://schema.org/DesktopWebPlatform', 'https://schema.org/MobileWebPlatform']
          },
          result: { '@type': 'Reservation', name: lang === 'fr' ? 'Demande de transport' : 'Vervoersaanvraag' }
        }
      },
      serviceCatalog
    ];

    if (isKnownPage) {
      const webPage = {
        '@type': 'WebPage',
        '@id': `${canonicalUrl}#webpage`,
        url: canonicalUrl,
        name: page.title,
        description: page.description,
        keywords: (page.keywords || []).join(', '),
        isPartOf: { '@id': `${origin}/#website` },
        about: { '@id': `${origin}/#organization` },
        inLanguage: language
      };

      if (page.serviceName) {
        webPage.mainEntity = { '@id': `${canonicalUrl}#service` };
      }

      graph.push(webPage);

      if (page.serviceName) {
        graph.push({
          '@type': 'Service',
          '@id': `${canonicalUrl}#service`,
          name: page.serviceName,
          serviceType: page.serviceType,
          description: page.description,
          url: canonicalUrl,
          provider: { '@id': `${origin}/#organization` },
          areaServed: {
            '@type': 'AdministrativeArea',
            name: normalizedPathname === '/transport-medical-anderlecht'
              ? 'Anderlecht et Région de Bruxelles-Capitale'
              : 'Région de Bruxelles-Capitale'
          },
          availableChannel: {
            '@type': 'ServiceChannel',
            serviceUrl: `${origin}/reservation`,
            servicePhone: {
              '@type': 'ContactPoint',
              telephone: '+32491333777',
              contactType: 'reservations'
            }
          }
        });
      }

      if (normalizedPathname !== '/') {
        graph.push({
          '@type': 'BreadcrumbList',
          '@id': `${canonicalUrl}#breadcrumb`,
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: lang === 'fr' ? 'Accueil' : 'Home', item: `${origin}/` },
            { '@type': 'ListItem', position: 2, name: page.breadcrumb, item: canonicalUrl }
          ]
        });
      }

      if (normalizedPathname === '/faq') {
        graph.push({
          '@type': 'FAQPage',
          '@id': `${canonicalUrl}#faq`,
          mainEntity: Array.from({ length: 9 }, (_, index) => ({
            '@type': 'Question',
            name: t(`translate.faq_q${index + 1}_title`),
            acceptedAnswer: { '@type': 'Answer', text: t(`translate.faq_q${index + 1}_answer`) }
          }))
        });
      }
    }

    const structuredData = { '@context': 'https://schema.org', '@graph': graph };
    let script = document.head.querySelector('#main-tendue-structured-data');
    if (!script) {
      script = document.createElement('script');
      script.id = 'main-tendue-structured-data';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(structuredData);
  }, [pathname, lang, t]);

  return null;
}

export default Seo;
